import 'alpinejs/dist/alpine-ie11'
// import { CountUp } from './countUp/dist/countUp.min.js'


// (function ($) {
//
//     $.fn.inViewport = function (offsetVh) {
//         var elOffsetVh = ~~Math.round(parseFloat(offsetVh)) || 0;
//         var elT = $(this).offset().top;
//         var elB = elT + $(this).outerHeight();
//         var viewT = $(window).scrollTop();
//         var viewB = viewT + ($(window).height() + elOffsetVh);
//         return elB > viewT && elT < viewB;
//     };
//
// }(jQuery));
//
// // find the <span> - Element with the class="count-up-number"
// // this script is easy to reuse
// // just create a <span class="count-up-number" data-count-up-time="3" data-count-up="{yournumber}">0</span>
// // somewhere in your pages
// jQuery(document).ready(function () {
//     jQuery(document).scroll(function () {
//         jQuery('.count-up-number').each(function () {
//
//             // start only when countUp did not ran yet - class="counted-up" is not set
//             if (!jQuery(this).hasClass('counted-up')) {
//
//                 // in viewport?
//                 if (jQuery(this).inViewport(0)) {
//
//                     const options = {
//                         duration: jQuery(this).attr('data-count-up-time')
//                     };
//
//                     const endVal = jQuery(this).attr('data-count-up');
//                     const countUp = new CountUp(this, endVal, options);
//
//                     // start the counter
//                     countUp.start();
//
//                     // set the counted-up class - so the counter starts only one time
//                     jQuery(this).addClass('counted-up');
//
//                 }
//
//                 // countUp ran
//             } else {
//
//                 // not in viewport?
//                 if (!jQuery(this).inViewport(0)) {
//
//                     // reset the counter
//                     // remove the counted-up class
//                     // so the couter starts again - when viewport is entered
//                     jQuery(this).removeClass('counted-up');
//
//                 }
//             }
//         });
//     });
// });
